import { render, staticRenderFns } from "./ManualFeesSection.vue?vue&type=template&id=ea29f808&scoped=true&"
import script from "./ManualFeesSection.vue?vue&type=script&lang=js&"
export * from "./ManualFeesSection.vue?vue&type=script&lang=js&"
import style0 from "./ManualFeesSection.vue?vue&type=style&index=0&id=ea29f808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea29f808",
  null
  
)

export default component.exports